module.exports = __webpack_public_path__ + "img/base_imagenes.824a9c8c.gif";